export default "__VITE_ASSET__CQfN2AvM__"